import styled from '@emotion/styled';
import { Input } from 'antd';

export const StyledInput = styled(Input)`
  border-radius: 50px;
  width: 100%;
`;
